import countries from "i18n-iso-countries";

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
countries.registerLocale(require("i18n-iso-countries/langs/de.json"));
